import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { usePopper } from 'react-popper';
import Context from './Context';
import { useUniqueId } from '../../hooks';
const Tooltip = ({ children, triggers = ['click'], placement = 'bottom', offset = 5, defaultIsOpen = false, hasArrow = true, modifiers = [], }) => {
    const targetClassName = useUniqueId('popover-target');
    const [refTarget, setRefTarget] = useState(null);
    const [refContent, setRefContent] = useState(null);
    const [refArrow, setRefArrow] = useState(null);
    const [isOpen, setIsOpen] = useState(defaultIsOpen);
    const { styles, attributes } = usePopper(refTarget, refContent, {
        placement,
        modifiers: [
            { name: 'arrow', options: { element: refArrow }, enabled: hasArrow },
            {
                name: 'offset',
                options: {
                    offset: [0, offset + 6],
                },
            },
            ...modifiers,
        ],
    });
    const context = {
        setRefTarget,
        setRefContent,
        setRefArrow,
        setIsOpen,
        refArrow,
        refTarget,
        refContent,
        styles,
        attributes,
        triggers,
        hasArrow,
        targetClassName,
        isOpen,
    };
    return _jsx(Context.Provider, { value: context, children: children });
};
export default Object.assign(memo(Tooltip), { displayName: 'Tooltip' });
